import { Dayjs } from "dayjs";

export type DateRangePreset = {
	display: string;
	from: string;
	to: string;
};

export type DateRange = {
	from: string | null;
	to: string | null;
};

export type DateRangeParsed = {
	from?: Dayjs | null;
	to?: Dayjs | null;
};

export type PeriodSelection = {
	from: string;
	to: string;
	from_parsed?: Date;
	to_parsed?: Date;
};

export const dateRangePresets: DateRangePreset[] = [
	{ from: "now/d", to: "now/d", display: "Today" },
	{ from: "now/d", to: "now", display: "Today so far" },
	{ from: "now/w", to: "now/w", display: "This week" },
	{ from: "now/w", to: "now", display: "This week so far" },
	{ from: "now/M", to: "now/M", display: "This month" },
	{ from: "now/M", to: "now", display: "This month so far" },
	{ from: "now/y", to: "now/y", display: "This year" },
	{ from: "now/y", to: "now", display: "This year so far" },

	{ from: "now-1d/d", to: "now-1d/d", display: "Yesterday" },
	{
		from: "now-2d/d",
		to: "now-2d/d",
		display: "Day before yesterday",
	},
	{
		from: "now-7d/d",
		to: "now-7d/d",
		display: "This day last week",
	},

	{ from: "now/y", to: "now/y-3Q", display: "Q1 (Jan-Mar)" },
	{ from: "now/y+1Q", to: "now/y-2Q", display: "Q2 (Apr-Jun)" },
	{ from: "now/y+2Q", to: "now/y-1Q", display: "Q3 (Jul-Sep)" },
	{ from: "now/y+3Q", to: "now/y", display: "Q4 (Oct-Dec)" },

	{ from: "now-1w/w", to: "now-1w/w", display: "Previous week" },
	{ from: "now-1M/M", to: "now-1M/M", display: "Previous month" },
	{ from: "now-1y/y", to: "now-1y/y", display: "Previous year" },

	{ from: "now-15m", to: "now", display: "Last 15 minutes" },
	{ from: "now-1h", to: "now", display: "Last 1 hour" },
	{ from: "now-6h", to: "now", display: "Last 6 hours" },
	{ from: "now-24h", to: "now", display: "Last 24 hours" },
	{ from: "now-7d", to: "now", display: "Last 7 days" },
	{ from: "now-30d", to: "now", display: "Last 30 days" },
	{ from: "now-90d", to: "now", display: "Last 90 days" },
	{ from: "now-6M", to: "now", display: "Last 6 months" },
	{ from: "now-1y", to: "now", display: "Last 1 year" },
	{ from: "now-2y", to: "now", display: "Last 2 years" },
	{ from: "now-5y", to: "now", display: "Last 5 years" },
];
